import {createReducer} from '@reduxjs/toolkit';

import {
  resetStateAction,
  setAccessTradeClickIdAction,
  setAppModeAction,
  setAppVersionAction,
  setCurrentStoreAction,
  setDefaultMembershipCardAction,
  setDeviceOSAction,
  setIsAppLoadingAction,
  setIsDirectCheckoutAction,
  setIsFromBasketNotification,
  setMembershipCardsAction,
  setNeedRetriggerCheckoutAction,
  setPricezaClickIdAction,
  setShowBuildInfo,
  setStoreAreasAction,
  setTrueIdAction,
  setMpidAction,
  setVoucherDataAction,
  setIsStoreInactiveAction
} from 'store/actions/app-action';
import {AppState} from 'store/types/app';

import {config} from '../../config/env';
import {AppMode} from '../../constants';

const initialState: AppState = {
  defaultMembershipCard: undefined,
  membershipCards: [],
  voucherData: undefined,
  currentStore: undefined,
  locations: null,
  isDirectCheckout: false,
  accessTradeClickId: undefined,
  pricezaClickId: undefined,
  isAppLoading: false,
  appMode: AppMode.regular,
  appVersion: undefined,
  deviceOS: undefined,
  resetEffectValue: 0,
  isFromBasketNotification: false,
  trueId: undefined,
  mpid: undefined,
  showBuildInfo: config.SENTRY_ENV !== 'production',
  needRetriggerCheckout: false,
  isStoreInActive: false
};

const AppReducer = createReducer(initialState, (builder) => {
  builder.addCase(setDefaultMembershipCardAction, (state, action) => {
    return {
      ...state,
      defaultMembershipCard: action.payload
    };
  });

  builder.addCase(setShowBuildInfo, (state, action) => {
    return {
      ...state,
      showBuildInfo: action.payload
    };
  });

  builder.addCase(setMembershipCardsAction, (state, action) => {
    return {
      ...state,
      membershipCards: action.payload
    };
  });

  builder.addCase(setVoucherDataAction, (state, action) => {
    return {
      ...state,
      voucherData: action.payload
    };
  });

  builder.addCase(setCurrentStoreAction, (state, action) => {
    return {
      ...state,
      currentStore: action?.payload
    };
  });

  builder.addCase(setStoreAreasAction, (state, action) => {
    return {
      ...state,
      locations: action?.payload
    };
  });

  builder.addCase(setIsDirectCheckoutAction, (state, action) => {
    return {
      ...state,
      isDirectCheckout: action?.payload
    };
  });

  builder.addCase(setAccessTradeClickIdAction, (state, action) => {
    return {
      ...state,
      accessTradeClickId: action?.payload
    };
  });

  builder.addCase(setPricezaClickIdAction, (state, action) => {
    return {
      ...state,
      pricezaClickId: action?.payload
    };
  });

  builder.addCase(setTrueIdAction, (state, action) => {
    return {
      ...state,
      trueId: action?.payload
    };
  });

  builder.addCase(setMpidAction, (state, action) => {
    return {
      ...state,
      mpid: action?.payload
    };
  });

  builder.addCase(setIsAppLoadingAction, (state, action) => {
    return {
      ...state,
      isAppLoading: action?.payload
    };
  });
  builder.addCase(setAppModeAction, (state, action) => {
    return {
      ...state,
      appMode: action?.payload
    };
  });
  builder.addCase(setAppVersionAction, (state, action) => {
    return {
      ...state,
      appVersion: action?.payload
    };
  });
  builder.addCase(setDeviceOSAction, (state, action) => {
    return {
      ...state,
      deviceOS: action?.payload
    };
  });
  builder.addCase(resetStateAction, (state) => {
    const resetEffectValue = Math.random();
    return {
      ...state,
      resetEffectValue
    };
  });
  builder.addCase(setIsFromBasketNotification, (state, action) => {
    return {
      ...state,
      isFromBasketNotification: action?.payload
    };
  });

  builder.addCase(setNeedRetriggerCheckoutAction, (state, action) => {
    return {
      ...state,
      needRetriggerCheckout: action?.payload
    };
  });
  builder.addCase(setIsStoreInactiveAction, (state, action) => {
    return {
      ...state,
      isStoreInActive: action?.payload
    };
  });
});

export default AppReducer;
